<template>
  <el-divider />
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-wrapper">
        <div class="footer-links">
          <router-link to="/faq" class="footer-link">常见问题</router-link>
          <router-link to="/about" class="footer-link">关于</router-link>
          <router-link to="/contact" class="footer-link">联系我们</router-link>
          <router-link to="/terms" class="footer-link">服务条款</router-link>
        </div>
        <div class="copyright">
          © 2025 Half Panda. All Rights Reserved
        </div>
      </div>
    </div>
  </footer>
  <el-divider />
</template>

<script>
export default {
  name: 'BlogFooter'
}
</script>

<style scoped>
.footer {
  padding: 0.5rem 0;
  margin-top: 1rem;
  /* 移除阴影 */
  box-shadow: none;
  background-color: transparent;
}

.footer-content {
  /* 调大最大宽度，让页脚更宽 */
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  text-align: center;
}

.footer-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.footer-links {
  display: flex;
  gap: 2rem;
  margin-bottom: 0;
}

.footer-link {
  color: #333;
  text-decoration: none;
  transition: all 0.3s ease;
  position: relative;
  padding-bottom: 0px;
}

.footer-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #3498db;
  transition: width 0.3s ease;
}

.footer-link:hover {
  color: #3498db;
}

.footer-link:hover::after {
  width: 100%;
}

.copyright {
  font-size: 0.9rem;
  opacity: 0.8;
  letter-spacing: 0.5px;
  color: #333;
}
</style>
